// import React from "react";
// import UpdateMeetingForm from "./UpdateMeetingForm";

// const UpdateMeetingDashboard = () => {
//   return (
//     <div className="admin-container">
//       <div className="max-w-xl w-full shadow-lg rounded-lg p-6 space-y-6">
//         <h2 className="text-3xl font-semibold text-gray-800 text-center">Update Session</h2>
//         <UpdateMeetingForm />
//       </div>
//     </div>
//   );
// };

// export default UpdateMeetingDashboard;


import React, { useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../../components/Navbar";
import UpdateMeetingForm from "./UpdateMeetingForm";
import { useNavigate } from "react-router-dom";


const UpdateMeetingDashboard = () => {
  const {
        isAdmin,
      } = useContext(AuthContext);

    const navigate = useNavigate();
      useEffect(() => {
        if (!isAdmin) {
          navigate("/", { replace: true });
        }
      }, [isAdmin, navigate]);
  return (
  <div
    className="min-h-screen w-screen flex flex-col"
    style={{
      background: "linear-gradient(to bottom, #24004266 40%, #4FCBE6 100%)",
    }}
  >
    {/* Navbar at the top */}
    <Navbar />

    {/* Centered content */}
    <div className="flex flex-1 items-center justify-center px-4 mt-10">
      <div className="max-w-xl w-full bg-white shadow-lg rounded-lg p-6 space-y-6">
        <h2 className="text-3xl font-semibold text-gray-800 text-center">
          Update Meeting
        </h2>
        <UpdateMeetingForm />
      </div>
    </div>
  </div>
);
};

export default UpdateMeetingDashboard;
